// DAS-3317: the Ticker Alpha sentence as one short label for the alert cards ("α +5.7% / 6 mo"),
// with the full sentence for the hover. The sentence itself stays tickerAlpha.js's job.
import { tickerAlphaText, isSellAlert } from './tickerAlpha';

// The card date reaches the page as an HTTP date ("Fri, 30 Oct 2026 00:00:00 GMT") and the
// sentence keeps its first 10 characters, which cut it to "Fri, 30 Oc". Hand it an ISO date.
export function isoCardDate(raw) {
  if (!raw) return raw;
  const s = String(raw);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? s : d.toISOString().slice(0, 10);
}

export function tickerAlphaSentence(alert) {
  if (!alert) return null;
  return tickerAlphaText({ ...alert, alpha_card_date_at_initiation: isoCardDate(alert.alpha_card_date_at_initiation) });
}

// { label, tone, tooltip } or null when the alert carries no card. tone: 'success' when the edge
// backs the alert (a gain on a buy, a lag on a sell), 'error' when it argues against it.
export function tickerAlphaChip(alert) {
  const sentence = tickerAlphaSentence(alert);
  if (!sentence) return null;
  const amount = Number(alert.alpha_edge_at_initiation);
  if (!Number.isFinite(amount) || amount === 0) return { label: 'α none', tone: 'default', tooltip: sentence };
  const pct = (Math.abs(amount) / 100).toFixed(1);   // € per €10,000 -> percent
  const months = (sentence.match(/ over (\d+) months/) || [])[1];
  const label = `α ${amount > 0 ? '+' : '−'}${pct}%${months ? ` / ${months} mo` : ''}`;
  const backs = (amount > 0) !== isSellAlert(alert);
  return { label, tone: backs ? 'success' : 'error', tooltip: sentence };
}

export default tickerAlphaChip;
